import Item from "./Item";
import './Transaction.css'
import DataContext from './../data/DataContext';
import { useContext } from "react";




const Transaction=(props)=>{
    const {item} = props
    const {income,expense} = useContext(DataContext)


    return(
      <div>
      <ul className="item-list">  
        {item.map((element)=>{
          return <Item {...element} key={element.id}></Item>
        })}
         
        
         
        </ul>
        

        </div>
    );
  }

  export  default Transaction